import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	savedAsTemplateInlineMessage: {
		id: 'spa-apps-sidebar-common.custom-template-inline-message.saved-as-template-inline-message.non-final',
		defaultMessage: 'Saved as template',
		description: 'Inline message title to show that a project has been set as a live template',
	},
	savedAsTemplateDialogMessage: {
		id: 'spa-apps-sidebar-common.custom-template-inline-message.saved-as-template-dialog-message.non-final',
		defaultMessage:
			'This project is saved as a custom template. Project settings changes will apply to the template.',
		description:
			'dialog message to provide more details about the project being set as a custom template',
	},
});
